import { createContext } from 'react';
import _noop from 'lodash/noop';

export const UploadTracksContext = createContext<UploadTracksProviderValue>({
    cancel: _noop,
    handleFileForTrack: _noop,
});
